'use strict';

/**
 * @file
 * Utilities for handling and manipulating strings
 **/

/**
 * From a given string, extract and return the last word in that sequence
 *
 * This is used to help in sorting the requirement citations in order.
 *
 * @param {string} Input string
 * @return {string}
 */
export function strExtractLast (string) {
  const separated = string.split(' ');
  let lastWord = separated.pop();
  
  if (!lastWord.startsWith('s')) {
	  lastWord = separated.pop() + ' ' + lastWord;
  }

  return lastWord;
}

export { strExtractLast as 'module.exports' };
